module.exports = __webpack_public_path__ + "static/media/Arctic_Law_2026_PDF.f3f93a5e.pdf";